// util/missingInformationModal.js
// Centralizes logic for MissingInformationModal rules + reminder resolution.

export const EMAIL_VERIFICATION = 'EMAIL_VERIFICATION';

export const MISSING_INFORMATION_MODAL_WHITELIST = [
  // Pages where the modal is allowed to show (and logic may redirect user)
  'LoginPage',
  'SignupPage',
  'ContactDetailsPage',
  'EmailVerificationPage',
  'PasswordResetPage',
  'StripePayoutPage',
];

// Transaction pages (/order/:id, /sale/:id) require params and should NOT be
// included in the whitelist since ModalMissingInformation builds whitelist URLs
// via pathByRouteName and would crash without an :id param.
export const isOrderOrSalePage = pathname => {
  const path = pathname || '';
  return /^\/(order|sale)\/.+/.test(path);
};

export const resolveHideCloseButton = pathname => {
  return isOrderOrSalePage(pathname);
};

// ✅ NEW helper: use this before any whitelist path generation or reminder checks
export const shouldSkipMissingInformationModal = pathname => {
  return isOrderOrSalePage(pathname);
};

export const resolveMissingInformationReminder = params => {
  const {
    currentUser,
    currentUserHasListings,
    currentUserHasOrders,
    pathname, // optional but recommended
  } = params || {};

  // ✅ Do not show reminder on order/sale pages
  if (shouldSkipMissingInformationModal(pathname)) return null;

  const hasOrders = currentUserHasOrders === true;
  const hasListingsOrOrders = !!currentUserHasListings || hasOrders;

  const emailUnverified = !!currentUser?.id && !currentUser?.attributes?.emailVerified;
  const emailVerificationNeeded = hasListingsOrOrders && emailUnverified;

  return emailVerificationNeeded ? EMAIL_VERIFICATION : null;
};

// ✅ NEW: force reminder (used by TransactionPage)
export const resolveMissingInformationReminderWithForce = params => {
  const { forceOpenEmailVerification, pathname } = params || {};

  // ✅ Even if forced, do not show on order/sale pages
  if (shouldSkipMissingInformationModal(pathname)) return null;

  if (forceOpenEmailVerification) return EMAIL_VERIFICATION;
  return resolveMissingInformationReminder(params);
};
